<template>
    <div>
      <div class="com-page-title">
        <div class="inner" v-html="parentInfo.name?.replace(/\n/gi, '<br>')" />
      </div>
      <div class="com-card">
        <div class="com-card-title">
          <DictionaryText typeCode="gongfengfangshi" :dictValue="payload.way"/>
          <template v-if="!['观音祈福', '除夕迎春祈福法会','元旦新春祈福法会'].includes(parentInfo.name)"> · </template>
          {{ payload.type == 1 ? '内坛 · ' : (payload.type == 2 ? '外坛 · ' : '') }}
          <DictionaryText typeCode="paiweidaxiao" :dictValue="payload.size" v-if="!['观音祈福', '除夕迎春祈福法会','元旦新春祈福法会'].includes(parentInfo.name)"/>
          <span class="right-txt">¥{{ payload.price }}</span>
        </div>
        <div class="com-card-content">
          <div class="text-wrap">
            <p>{{ payload.brief }}</p>
          </div>
          <br>
          <template v-if="payload.price">
            <div class="van-hairline--bottom" />
            <br>
            <div class="com-form-wrap">
              <van-form>
                <van-field
                  class="field-yellow"
                  label="尺寸规格"
                  readonly
                  colon
                >
                  <template #input>
                    <DictionaryText typeCode="chicunguige" :dictValue="payload.specification"/>
                  </template>
                </van-field>
                <van-field
                  class="field-yellow"
                  :label="['quannianlianwei', 'quannianluwei'].includes(payload.way) ? '供奉年度' : '供奉时间'"
                  readonly
                  colon
                >
                  <template #input>
                    {{ parentInfo.date }}(农历)
                  </template>
                </van-field>
                <van-field
                  v-if="parentInfo.location"
                  class="field-yellow"
                  label="供奉位置"
                  readonly
                  colon
                >
                  <template #input>
                    <span v-if="payload.type == 1">演法堂</span>
                    <span v-else-if="payload.type == 2">大雄宝殿</span>
                    <DictionaryText v-else typeCode="gongfengweizhi" :dictValue="parentInfo.location"/>
                  </template>
                </van-field>
              </van-form>
              <div class="com-form-submit">
                <DefaultBtn @click="$router.push({ path: 'record', query: { ...$route.query } })">登记信息</DefaultBtn>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
</template>

<script>
  import DictionaryText from '@/components/common/DictionaryText'
  export default {
    data () {
      return {
        payload: {},
        // 从父级获取法会信息
        parentInfo: {}
      }
    },
    mounted () {
      this.getData()
      this.getFaHuiInfo()
    },
    methods: {
      // 供奉详情
      getData () {
        this.$faWuApi.faHui.getSubDetail({
          id: this.$route.query.id
        }).then(res => {
          if (res.success) {
            this.payload = res.data
          }
        })
      },
      // 获取法会信息
      getFaHuiInfo () {
        this.$faWuApi.faHui.getItemData({
          id: this.$route.query.pId
        }).then(res => {
          if (res.success) {
            this.parentInfo = res.data
          } else {
            this.$toast(res.errMessage)
          }
        })
      }
    },
    components: {
      DictionaryText
    }
  }
</script>